import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=0bd41922"
import script from "./RejectModal.vue?vue&type=script&lang=ts"
export * from "./RejectModal.vue?vue&type=script&lang=ts"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=0bd41922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports